import { useContext, useEffect,useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, LinearProgress, Stack } from "@mui/material";
import { CasUserContext, useCasUserContext } from "../../services/casUserContext";
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from "../../interfaces/ProductoTerminadoDTO";
import { TblProductoProdTermin, setProductoConferencia, } from "../../interfaces/TblProductoProdTermin";
import { ProductoAreaConocimientoDTO, getVoidProductoAreaConocimientoDTO } from "../../interfaces/ProductoAreaConocimientoDTO";
import { ProductoLineaInvestigacionDTO, getVoidProductoLineaInvestigacionDTO } from "../../interfaces/ProductoLineaInvestigacionDTO";
import { ProductoColaboradorDTO, setListProductoColConferencia } from "../../interfaces/ColaboradorProdcutoDTO";
import { ProductoTerminadoObjOdDTO, getVoidProductoTerminadoObjOdDTO } from "../../interfaces/ProductoTerminadoObjOdDTO";
import { TblDecInvMotivoProdTermin, setProductoMotivo } from "../../interfaces/TblDecInvMotivoProdTermin";
import ProductoService from "../../services/ProductoService";
import ProductoForm from "../../componentes/Productos/ProductoForm";
import UsuarioService from "../../services/UsuarioService";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { EmailProductoCreado, setEmailProductoCreado } from "../../interfaces/MailModel";
import EmailService from "../../services/EmailService";

const productoService = new ProductoService();
const usuarioService = new UsuarioService();
const emailService = new EmailService();

export const FormConferenciaPage: React.FC<{}> = () =>{
    //Seccion variables
    let {id,idproducto} = useParams();
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const idusuariocrea = casUserContext.userData.idinv;
    const idpersona = casUserContext.userData.idpersona;
    const user = casUserContext.userData;
    const [ready,setReady] = useState(false); 
    const [datosFormulario,setDatosFormulario] = useState<ProductoTerminadoDTO>(()=> getVoidProdcutoTerminadoDTO());
    const[auth,setAuth] = useState(false);
    let history = useNavigate();
    //Seccion de carga
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        setAuth(flag);
        if(flag){
            fetchData();
        }
    },[]);
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        setAuth(flag);
        if(flag){
            fetchData();
        }
    },[token]);
    //seccion Funciones
    const fetchData = async () =>{
        setReady(false);
        try{
             await productoService.GetConferenciaById(parseInt(idproducto || '0'),token)
             .then((data) => {
                data.data.idCategoriaProducto = 3;
                //console.log(data)  
                setProducto(data)
                })               
             .catch((error) => console.error(error));                       
        }catch(error){
          console.error('Error:',error);
        }
        //setReady(true);
    };
    function setProducto(data: any) {
        //console.log(data.objDatos);
        setDatosFormulario({
            ...datosFormulario,
            producto: setProductoConferencia(data.data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.data.motivo) as TblDecInvMotivoProdTermin,
            areaConocimiento:  getVoidProductoAreaConocimientoDTO() as ProductoAreaConocimientoDTO,
            lineaInvestigacion: getVoidProductoLineaInvestigacionDTO() as ProductoLineaInvestigacionDTO,
            ods: getVoidProductoTerminadoObjOdDTO() as ProductoTerminadoObjOdDTO,
            colProducto: setListProductoColConferencia(data.data.colProducto) as Array<ProductoColaboradorDTO>,            
            //adjuntos: setListFileModel(data.objDatos.adjuntos) as Array<FileModel>,
            idpersona: idpersona,
            idCategoriaProducto: data.data.idCategoriaProducto as number,
        });
        setReady(true);
    }
    const goToNavigation = (site:string) =>{
        history(site)
    }
    const handleResponse = async (responseData: ProductoTerminadoDTO) => {
        // Manejar la respuesta aquí
        //console.log('Respuesta recibida:', responseData);
        var obt:EmailProductoCreado = setEmailProductoCreado("Ingreso de Conferencia",user.emailAddress,responseData);
        const resp = await emailService.MailProductoCreado(obt,token); 
        goToNavigation('/Producto/MisProductos');
    };   

    return(
        <Container sx={{mt:2, mb:4}}>
            <br />
            {auth ? 
            <>{ready ?
            <ProductoForm usoProyectosParticipo defaultTipo={43} productoterminado={datosFormulario} idProducto={id || '0'} onResponse={handleResponse} tiposAvalible={[]} categoriasAvalible={[]} />
            :
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                <LinearProgress color="secondary" />
            </Stack>}
            </>
            :
            <UnauthorizedPage />
            }
        </Container>
    );
}